import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { useReducedMotion } from "@/hooks/useReducedMotion";

export default function Statement({ settings, onOrder }) {
  const ref = useRef(null);
  const reduced = useReducedMotion();
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  // Vertraagde (parallax) verticale beweging van de achtergrond t.o.v. de scroll
  const yBg = useTransform(scrollYProgress, [0, 1], reduced ? ["0%", "0%"] : ["-12%", "12%"]);

  return (
    <section ref={ref} className="relative flex min-h-[90vh] items-center justify-center overflow-hidden px-5 py-28 lg:px-10">
      {/* Parallax-achtergrond: SoulFoodCity-logo, cover + gecentreerd */}
      <motion.div style={{ y: yBg }} className="absolute inset-x-0 -top-[15%] -bottom-[15%] z-0" aria-hidden="true">
        <img
          src="/soulfoodcity-logo.webp"
          alt=""
          className="h-full w-full object-cover object-center"
        />
      </motion.div>

      {/* Subtiele overlay voor leesbaarheid */}
      <div className="absolute inset-0 z-0 bg-gradient-to-b from-sfc-night/85 via-sfc-purple/60 to-sfc-night/90" />
      <div className="absolute inset-0 z-0 bg-sfc-night/30" />

      <div className="relative z-10 mx-auto max-w-5xl text-center">
        <motion.h2
          initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.8 }}
          className="font-display text-5xl font-semibold leading-[0.95] tracking-tight text-white [text-shadow:0_4px_30px_rgba(0,0,0,0.6)] sm:text-7xl lg:text-8xl"
        >
          {settings?.statement_heading || "De smaak is nog maar het begin."}
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.7, delay: 0.1 }}
          className="mx-auto mt-8 max-w-xl text-base text-white/85 [text-shadow:0_2px_16px_rgba(0,0,0,0.7)] sm:text-lg"
        >
          Van eerste slok tot vaste waarde op uw kaart. Zet vandaag de stap naar een onderscheidend drankconcept voor uw zaak.
        </motion.p>
        <motion.button
          data-testid="statement-order-cta"
          onClick={onOrder}
          initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.7, delay: 0.2 }}
          className="mt-10 rounded-full bg-white px-8 py-4 text-sm font-semibold text-sfc-night shadow-2xl transition-transform duration-300 hover:scale-105"
        >
          Start uw zakelijke bestelling
        </motion.button>
      </div>
    </section>
  );
}
